import { AlertTriangle } from 'lucide-react'

import { Tooltip, TooltipContentShort, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'
import { cn } from '@/ui/utils/style'

interface WarnProps {
  size?: number
  children: React.ReactNode
  className?: string
}

function Warn({ children, size = 14, className }: WarnProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <AlertTriangle size={size} className={cn('text-muted-foreground', className)} />
      </TooltipTrigger>
      <TooltipContentShort>{children}</TooltipContentShort>
    </Tooltip>
  )
}

export { Warn, type WarnProps }
